import init from "../../../../lib/common/js/init"
import components from "./components"
import dataStore from "./dataStore"

init({
  components,
  dataStore,
})
